<template>
  <div class="box-filtres">
    <table>
      <tbody>
        <tr>
          <td width="150px">
            <input id="fechainicio" placeholder="Fecha inicio" datatype="fecha"  type="text" class="form-control" autocomplete="off">
          </td>
          <td width="150px">
            <input id="fechafin" placeholder="Fecha final"  datatype="fecha"  type="text" class="form-control" autocomplete="off">
          </td>
          <td width="150px">
            <select :value="tipo" class="form-control" @change="$emit('tipo', $event.target.value)">
              <option value="1">ACTIVAS</option>
              <option value="2">ANULADAS</option>
              <option value="3">TODAS</option>
              <option value="4">NC PARCIALES</option>
            </select>
          </td>
          <td>
            <button type="button" class="btn btn-warning" @click="$emit('consultar')">
              Consultar
            </button>
          </td>
          <td>
            <div v-if="loading">
              <img src="dist/img/kubber-loading.gif" style="width:30px">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    tipo: String,
    loading: Boolean
  }
};
</script>